module.exports = __webpack_public_path__ + "img/2025-05_research-innovation-global-impact.aea17c35.webp";